import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedServiceService {
  private menuRefreshSubject = new Subject<void>();
  menuRefresh$ = this.menuRefreshSubject.asObservable();

  triggerMenuRefresh() {
    this.menuRefreshSubject.next();
  }
}
